"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveTabIdFromRoute = exports.getLastNumericTokenFromPath = exports.getLastURLPathElement = exports.getIdFromRouteParams = exports.getFullPathFromRouting = exports.getPathNameFromRouting = exports.getLocationFromRouting = void 0;

var _getLastNumericTokenInURL = _interopRequireDefault(require("../utils/getLastNumericTokenInURL"));

var _reselect = require("reselect");

var getLocationFromRouting = function getLocationFromRouting(state) {
  return state.routing.locationBeforeTransitions;
};

exports.getLocationFromRouting = getLocationFromRouting;

var getPathNameFromRouting = function getPathNameFromRouting(state) {
  return state.routing.locationBeforeTransitions.pathname;
};

exports.getPathNameFromRouting = getPathNameFromRouting;

var getFullPathFromRouting = function getFullPathFromRouting(state) {
  return state.routing.locationBeforeTransitions.basename + state.routing.locationBeforeTransitions.pathname;
};

exports.getFullPathFromRouting = getFullPathFromRouting;

var getIdFromRouteParams = function getIdFromRouteParams(state, _ref) {
  var params = _ref.params;
  return parseFloat(params.id, 10);
};

exports.getIdFromRouteParams = getIdFromRouteParams;
var getLastURLPathElement = (0, _reselect.createSelector)([getFullPathFromRouting], function (path) {
  return path.substring(path.lastIndexOf('/') + 1);
});
/* This can be useful to grab the id of a sub element from the route
 when your component does not have access to route params.
 Ex: settings/99236212/website/blogs/3134182516/dateFormats ->
 If I wanted to grab the relevant blog ID from the path, to select the "3134182516"
 token, I could use this selector
 */

exports.getLastURLPathElement = getLastURLPathElement;
var getLastNumericTokenFromPath = (0, _reselect.createSelector)([getPathNameFromRouting], function (pathname) {
  return (0, _getLastNumericTokenInURL.default)(pathname);
});
exports.getLastNumericTokenFromPath = getLastNumericTokenFromPath;
var getActiveTabIdFromRoute = (0, _reselect.createSelector)([getLastURLPathElement], function (lastURLPathElement) {
  if (isNaN(parseInt(lastURLPathElement, 10))) {
    return lastURLPathElement;
  }

  return 'default';
});
exports.getActiveTabIdFromRoute = getActiveTabIdFromRoute;